var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c("div", { class: _vm.slideInClass }, [
        _vm.matrix
          ? _c(
              "nav",
              [
                _vm._l(_vm.matrix.categories, function(category) {
                  return [
                    _c("h4", [_vm._v(_vm._s(category.label))]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      _vm._l(category.rows, function(row) {
                        return _c(
                          "li",
                          {
                            key: row.id,
                            class: [
                              "more-left-padding",
                              {
                                active:
                                  _vm.selectedRow &&
                                  _vm.selectedRow.id === row.id
                              },
                              { disabled: !_vm.hasValues(row) },
                              { completed: _vm.hasFilteredValues(row) }
                            ]
                          },
                          [
                            _c(
                              "a",
                              {
                                attrs: { href: _vm.hasValues(row) ? "#" : "" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.selectRow(row)
                                  }
                                }
                              },
                              [
                                _vm.hasFilteredValues(row)
                                  ? _c("Icon", { attrs: { icon: "checkmark" } })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", { staticClass: "label" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(row.label) +
                                      "\n\t\t\t\t\t\t\t"
                                  ),
                                  _vm.hasFilteredValues(row)
                                    ? _c("span", [
                                        _vm._v(
                                          "(" +
                                            _vm._s(
                                              _vm.getFilteredValuesAmount(row)
                                            ) +
                                            ")"
                                        )
                                      ])
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                !_vm.hasValues(row)
                                  ? _c("span", { staticClass: "sublabel" }, [
                                      _vm._v("Derzeit keine")
                                    ])
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ]
                })
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "edit-area" }, [
          _c("header", { staticClass: "titled" }, [
            _c("div", [
              _c("h1", [
                _vm._v(_vm._s(_vm.selectedRow ? _vm.selectedRow.label : ""))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "close-container" }, [
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.closeFan(false)
                    }
                  }
                },
                [_c("Icon", { attrs: { icon: "close" } })],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "main",
            { staticClass: "scrollbar-check" },
            [
              _vm.loading
                ? _c("Loading")
                : [
                    !_vm.selectedRow
                      ? _c("div", [
                          _vm._v(
                            "Wähle links aus was du genauer filtern möchtest."
                          )
                        ])
                      : _c(
                          "div",
                          [_c("Row", { attrs: { row: _vm.selectedRow } })],
                          1
                        )
                  ]
            ],
            2
          ),
          _vm._v(" "),
          !_vm.loading
            ? _c(
                "footer",
                [
                  _c("Button", {
                    attrs: { text: "Ergebnisse anzeigen", icon: "checkmark" },
                    on: {
                      click: function($event) {
                        return _vm.closeFan(true)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }